module.exports = __webpack_public_path__ + "static/media/10427360_817897561631967_7210583443671821509_n_edited.afdb81a6.jpg";